// extracted by mini-css-extract-plugin
module.exports = {"StartAction":"StartAction_StartAction__3ieIu","badge":"StartAction_badge__29SoC","badgePulse":"StartAction_badgePulse__WP2uW","badgeStar":"StartAction_badgeStar__2O1t_"};